export const RESULT_OPTIONS = {
  File: 'file',
  Link: 'link',
  None: 'none',
};
